import React, { useContext } from "react";
import _ from "lodash";

import FullPaginationControls from "Components/fullPaginationControls/FullPaginationControls";
import ResponsiveTable from "Components/responsiveTable/ResponsiveTable";
import DomainStatusBadge from "Components/domainStatusBadge/DomainStatusBadge";

import ButtonBack from "Components/buttonBack/ButtonBack";
import { t } from "i18next";
import { Icon, imports as importsIcon } from "Icons/index";
import s from "./resourcesImports.scss";

import { useApiQuery } from "@/hooks";
import { AuthContext, MediaQueriesContext } from "@/App";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const ImportResourcesScreen = (props) => {
  const importCode = props.match.params.importCode;
  const { isLoggedUserAdmin } = useContext(AuthContext);

  const { isMobileDevice } = useContext(MediaQueriesContext);

  const location = useLocation();
  const history = useHistory();

  const {
    getData: getImportResources,
    data: importResources,
    pagination: importResourcesPagination,
    isRefreshing: importResourcesRefreshing,
    isLoading: importResourcesLoading,
  } = useApiQuery("getImportResources", {
    enablePagination: true,
    requestParams: importCode,
  });

  const goBack = () => {
    const query = _.get(location, "state.prevPagination", "");
    history.push("/imports" + query);
  };

  const tableHeaders =
    !importResourcesLoading && importResources[0]
      ? Object.keys(importResources[0].fields).map((tableHeader) => tableHeader)
      : [""];

  return (
    <div className={s.resourceImport}>
      <div className={s.navigation}>
        <ButtonBack onClick={goBack} />

        <div className={s.viewSectionLabel}>{t("section.view.import.resources")}</div>
      </div>

      <div className={s.header}>
        <div className={s.wrapTitle}>
          <div className="sectionTitle">{t("imports.resources.header.title")}</div>
        </div>

        {isLoggedUserAdmin() && (
          <div className={s.downloadFileLink}>
            <a target="_blank" href={`${BASE_URL}/imports/${importCode}/file`} rel="noreferrer">
              Scarica file .csv usato per la migrazione
            </a>
          </div>
        )}
      </div>

      <div className={s.settings}>
        <FullPaginationControls
          className={s.filters}
          paginationInfo={importResourcesPagination}
          location={location}
          refreshList={() => getImportResources(importCode)}
          listFilters={["all", "valid", "invalid"]}
          listFilterLegends={{
            all: <Icon svg={importsIcon} width="0.75rem" height="0.75rem" />,
            valid: <DomainStatusBadge status="valid" isHealthy showAsPreview />,
            invalid: <DomainStatusBadge status="invalid" isHealthy showAsPreview />,
          }}
          isLoading={importResourcesLoading || importResourcesRefreshing}
          totals={importResourcesPagination && importResourcesPagination.totals}
          showPaginationFilter={false}
          paginationShowOptions={[
            { value: 25, label: 25 },
            { value: 50, label: 50 },
            { value: 100, label: 100 },
            { value: 10000000, label: t("all") },
          ]}
        />

        <div className={s.table}>
          <ResponsiveTable
            verticalOnMobile
            history={history}
            areRowsLoading={importResourcesLoading}
            location={location}
            headers={[
              {
                name: t("table.header.status"),
                size: isMobileDevice ? "2rem" : "4rem",
                center: true,
              },
              { name: t("table.header.description"), size: "20rem" },

              ...tableHeaders.map((h) => ({
                name: t(`imports.resources.header.${h}`),
                invisible: importResourcesLoading || importResourcesRefreshing,
              })),
              { name: t("table.header.errors") },
            ]}
            rows={importResources.map((imp, inx) => {
              return (
                <tr key={imp.description + inx}>
                  <td data-label={t("table.header.status")}>
                    <DomainStatusBadge status={imp.status} isHealthy />
                  </td>
                  <td data-label={t("table.header.description")}>{imp.description}</td>
                  {tableHeaders.map((h) => (
                    <td
                      data-label={h}
                      style={{
                        maxWidth: "20rem",
                        wordBreak: "break-word",
                      }}
                      key={h}
                    >
                      {h === "password_type" ? t(`imports.resources.passwordType.${imp.fields[h]}`) : imp.fields[h]}
                    </td>
                  ))}
                  <td data-label={t("table.header.errors")}>
                    {imp.error_details &&
                      imp.error_details
                        .map((err) => {
                          if (typeof err === "string") {
                            return err;
                          } else {
                            return Object.values(err)[0];
                          }
                        })
                        .join(",")}
                  </td>
                </tr>
              );
            })}
          />
        </div>
      </div>
    </div>
  );
};

export default ImportResourcesScreen;
